import { request } from '../../request';

export function deleteSingleShift(shiftId: string) {
  return request.delete<void>(`/v2/shifts/${shiftId}`);
}

export function hardDeleteSingleShift(shiftId: string) {
  return request.delete<void>(`/v2/shifts/${shiftId}`);
}
